<template>
  <div class="web-page">
    <div class="web-page__content" :class="{ 'has-footer': hasFooter }">
      <div class="logo-box pa-4">
        <img style="max-width: 280px" src="../../../assets/logo.png" alt />
        <!-- <div class="lang-btn">
          <span
            @click="changeLang('zh-Hant')"
            :class="{ 'lang-active': $i18n.locale === 'zh-Hant' }"
            >繁</span
          >
          <span
            @click="changeLang('pt')"
            :class="{ 'lang-active': $i18n.locale === 'pt' }"
            >PT</span
          >
        </div> -->
      </div>
      <slot></slot>
    </div>
    <div>
      <div v-if="hasFooter" class="web-page-actions pa-4">
        <div class="web-page-actions__content">
          <slot name="actions"></slot>
        </div>
      </div>
      <div class="web-page-footer">
        <m-row>
          <m-col :xs="24" :sm="12">
            <div
              class="web-page-footer_item"
              v-html="$t('Common.title.message')"
            ></div>
          </m-col>
          <m-col :xs="24" :sm="12">
            <div class="web-page-footer_item">
              <div>
                <a
                  href="#"
                  style="
                    color: rgb(51, 122, 183);
                    text-decoration-line: none;
                    margin-right: 10px;
                  "
                  @click.stop="
                    showModal(
                      $t('floats.title.about-us'),
                      $t('floats.content.about-us')
                    )
                  "
                  >{{ this.$t("floats.title.about-us") }} </a
                ><a
                  href="#"
                  style="
                    color: rgb(51, 122, 183);
                    text-decoration-line: none;
                    margin-right: 10px;
                  "
                  @click.stop="
                    showModal(
                      $t('floats.title.contact-us'),
                      $t('floats.content.contact-us')
                    )
                  "
                  >{{ this.$t("floats.title.contact-us") }} </a
                ><a
                  href="#"
                  style="
                    color: rgb(51, 122, 183);
                    text-decoration-line: none;
                    margin-right: 10px;
                  "
                  @click.stop="
                    showModal(
                      $t('floats.title.privacy'),
                      $t('floats.content.privacy')
                    )
                  "
                  >{{ this.$t("floats.title.privacy") }}<br /></a
                >{{ this.$t("Common.title.reserved") }}
                <!-- <div>version：UAT-20250811-01</div> -->
              </div>
            </div></m-col
          >
        </m-row>
      </div>
    </div>
    <m-modal
      :visible.sync="modalVisible"
      :title="modalTitle"
      @ok="modalVisible = false"
      @cancel="modalVisible = false"
      :okText="$t('Common.action.confirm')"
      :cancelText="$t('Common.action.cancel')"
    >
      <div v-html="modalHtml"></div>
      <template slot="footer">
      <m-button ghost type="primary" @click="modalVisible = false">
        {{ $t('Common.action.close') }}
      </m-button>
    </template>
    </m-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalVisible: false,
      modalTitle: "",
      modalHtml: "",
    };
  },
  methods: {
    changeLang(key) {
      this.$i18n.locale = key;
      localStorage.setItem("currentLanguage", key);
      location.reload();
    },
    showModal(title, html) {
      this.modalVisible = true;
      this.modalTitle = title;
      this.modalHtml = html;
    },
  },
  computed: {
    hasFooter() {
      return !!this.$slots.actions;
    },
  },
};
</script>
<style scoped lang="scss">
.web-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
}
.web-page__content,
.web-page-actions__content {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}
.web-page__content.has-footer {
  padding-bottom: 68px;
}
.web-page-footer {
  min-height: 270px;
  /* padding: 0 12px;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #ffffff; */
  padding-top: 70px;
  color: #ffffff;
  background-image: url("@/assets/footer.png");
  background-size: cover;
  background-repeat: no-repeat;
  .web-page-footer_item {
    padding: 0px 10px 20px;
    font-size: 17px;
    justify-content: center;
    display: flex;
  }
}
.web-page-actions__content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.logo-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.lang-active {
  color: rgb(67, 166, 223);
  text-decoration: underline;
}
.lang-btn span {
  cursor: pointer;
  padding: 10px;
}
@media screen and (max-width: 767px) {
  .web-page-footer {
    padding-top: 20px;
  }
}
</style>
